import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import{ connect } from 'react-redux'
const ProtectedRoute = ({ component: Component, cartItem, ...rest }) => {

  return (
    <Route {...rest} render={
      props => {
        if (cartItem.length !== 0) {
          return <Component {...rest} {...props} />
        } else {
          return <Redirect to={
            {
              pathname: '/404',
              state: {
                from: props.location
              }
            }
          } />
        }
      }
    } />
  )
}


const mapStateToProps = state => {
    return {
      itemAdded: state.book.itemAdded,
      orderConfirmed: state.book.orderConfirmed
    };
  };
  
  export default connect(mapStateToProps, null)(ProtectedRoute);
  